import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule } from "@angular/forms";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { InputTextModule } from "primeng/inputtext";
import { DrawerModule } from "primeng/drawer";
import { BadgeModule } from "primeng/badge";
import { RadioButtonModule } from "primeng/radiobutton";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { TooltipModule } from "primeng/tooltip";
import { RippleModule } from "primeng/ripple";
import { AppConfigModule } from "./config/app.config.module";
import { AppLayoutComponent } from "./app.layout.component";
import { AppBreadcrumbComponent } from "./app.breadcrumb.component";
import { AppSidebarComponent } from "./app.sidebar.component";
import { AppTopbarComponent } from "./app.topbar.component";
import { AppProfileSidebarComponent } from "./app.profilesidebar.component";
import { AppMenuComponent } from "./app.menu.component";
import { AppMenuitemComponent } from "./app.menuitem.component";
import { RouterModule } from "@angular/router";
import { ButtonModule } from "primeng/button";
import { AutoCompleteModule } from "primeng/autocomplete";
import { FilterService } from "primeng/api";
import { CommonModule } from "@angular/common";

@NgModule({
  declarations: [
    AppLayoutComponent,
    AppBreadcrumbComponent,
    AppSidebarComponent,
    AppTopbarComponent,
    AppProfileSidebarComponent,
    AppMenuComponent,
    AppMenuitemComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    InputTextModule,
    DrawerModule,
    BadgeModule,
    RadioButtonModule,
    ToggleSwitchModule,
    ButtonModule,
    TooltipModule,
    RippleModule,
    RouterModule,
    AppConfigModule,
    AutoCompleteModule,
    CommonModule,
  ],
  providers: [FilterService, provideHttpClient(withInterceptorsFromDi())],
})
export class AppLayoutModule {}
